/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_V1_Interest_BondsInputs */

const en_onboarding_v1_interest_bonds = /** @type {(inputs: Onboarding_V1_Interest_BondsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bonds`)
};

const de_onboarding_v1_interest_bonds = /** @type {(inputs: Onboarding_V1_Interest_BondsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anleihen`)
};

const pt_br2_onboarding_v1_interest_bonds = /** @type {(inputs: Onboarding_V1_Interest_BondsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Títulos`)
};

const tr_onboarding_v1_interest_bonds = /** @type {(inputs: Onboarding_V1_Interest_BondsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tahviller`)
};

const zh_cn2_onboarding_v1_interest_bonds = /** @type {(inputs: Onboarding_V1_Interest_BondsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`债券`)
};

const zh_hk2_onboarding_v1_interest_bonds = /** @type {(inputs: Onboarding_V1_Interest_BondsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`債券`)
};

const ko_kr2_onboarding_v1_interest_bonds = /** @type {(inputs: Onboarding_V1_Interest_BondsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`채권`)
};

const ru_ru2_onboarding_v1_interest_bonds = /** @type {(inputs: Onboarding_V1_Interest_BondsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Облигации`)
};

const es_419_onboarding_v1_interest_bonds = /** @type {(inputs: Onboarding_V1_Interest_BondsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bonos`)
};

/**
* | output |
* | --- |
* | "Bonds" |
*
* @param {Onboarding_V1_Interest_BondsInputs} inputs
* @param {{ locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }} options
* @returns {LocalizedString}
*/
export const onboarding_v1_interest_bonds = /** @type {((inputs?: Onboarding_V1_Interest_BondsInputs, options?: { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_V1_Interest_BondsInputs, { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_onboarding_v1_interest_bonds(inputs)
	if (locale === "de") return de_onboarding_v1_interest_bonds(inputs)
	if (locale === "pt-BR") return pt_br2_onboarding_v1_interest_bonds(inputs)
	if (locale === "tr") return tr_onboarding_v1_interest_bonds(inputs)
	if (locale === "zh-CN") return zh_cn2_onboarding_v1_interest_bonds(inputs)
	if (locale === "zh-HK") return zh_hk2_onboarding_v1_interest_bonds(inputs)
	if (locale === "ko-KR") return ko_kr2_onboarding_v1_interest_bonds(inputs)
	if (locale === "ru-RU") return ru_ru2_onboarding_v1_interest_bonds(inputs)
	return es_419_onboarding_v1_interest_bonds(inputs)
});